// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"0437588d","148":"0aa424be","230":"088f21c5","453":"500a67db","825":"0ceb7852","874":"c57a38f9"}[chunkId] + ".chunk.js";
};